<template>
    <div>
        <div>
            <div v-if="devicePrice.banner">
                <ob1-tag :label="devicePrice.banner" />
            </div>
            <promo-prix-terminal
                v-if="devicePrice.promotion"
                class="mt-1"
                :promo-label="devicePrice.promotion.label"
                :promo-end-date="devicePrice.promotion.endDate"
            />
            <device-price
                class="d-block"
                :multiple-price="devicePrice.price.multiplePrice"
                :total-price-with-promo="devicePrice.price.totalPriceWithPromo"
                :total-price-without-promo="devicePrice.price.totalPriceWithoutPromo"
                :monthly-amount-in-cents="devicePrice.price.monthlyPayment ? devicePrice.price.monthlyPayment.monthlyAmountInCents : null"
                :monthly-duration="devicePrice.price.monthlyPayment ? devicePrice.price.monthlyPayment.duration : null"
                :taeg-rate="devicePrice.price.monthlyPayment ? devicePrice.price.monthlyPayment.taegRate : null"
                :generic-label="devicePrice.price.monthlyPayment ? devicePrice.price.monthlyPayment.genericLabel : null"
                :loan-rate-zero-label="getLoanRateZeroLabel(devicePrice.price)"
                :is-cents-format="true"
                :is-price-inversion-enabled="isPriceInversionEnabledForDevice(devicePrice.price)"
            />
            <cb4x-pxf-mention
                v-if="devicePrice.price.paymentInfoLabel"
                :payment-info-detail="devicePrice.price.paymentInfoLabel.detail"
                :link-label="devicePrice.paymentSolutionsDto.linkLabel"
                modal-id="popin-pxf-4xcb"
                is-from-mobile-detail
            />
            <!-- Popin de financement-->
            <pxf-cb4x-modal
                modal-id="popin-pxf-4xcb"
                :display-cb4x="devicePrice.price.cb4xAvailable"
                :display-pxf="devicePrice.price.pxfAvailable"
            >
                <template v-if="devicePrice.price.cb4xAvailable" #cb4x-content>
                    <!-- 4xCB payant  -->
                    <paying-detail-cb4x-modal-content
                        v-if="fundingDetails.cb4xPopin.withFees"
                        modal-id="popin-pxf-4xcb"
                        :oney-merchant-guid="fundingDetails.cb4xPopin.oneyMerchantGuid"
                        :oney-widget-src="fundingDetails.oneyWidgetSrc"
                        :counter-delay="fundingDetails.counterDelay"
                        :amount="devicePrice.price.totalPriceWithPromo / 100"
                        :header-block="fundingDetails.cb4xPopin.headerBlock"
                        :payment-example-block="fundingDetails.cb4xPopin.paymentExampleBlock"
                        :how-to-benefit="fundingDetails.cb4xPopin.howToBenefit"
                        :cgu="fundingDetails.cb4xPopin.cgu"
                        :illustration="fundingDetails.cb4xPopin.imageZen"
                    />
                    <!-- 4xCB gratuit avec détail du prix  -->
                    <cb4x-modal-content
                        v-else-if="devicePrice.price.spreadingPrice4xCbWithoutFees"
                        :header-block="fundingDetails.cb4xPopin.headerBlock"
                        :payment-block="fundingDetails.cb4xPopin.paymentBlock"
                        :payment-simulation-block="fundingDetails.cb4xPopin.paymentSimulationBlock"
                        :how-to-benefit="fundingDetails.cb4xPopin.howToBenefit"
                        :faq="fundingDetails.cb4xPopin.faqBlock"
                        :cgu="fundingDetails.cb4xPopin.cgu"
                        :monthly-price="devicePrice.price.spreadingPrice4xCbWithoutFees.monthlyPrice"
                        :first-monthly-price="devicePrice.price.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                        :one-shot-price="devicePrice.price.spreadingPrice4xCbWithoutFees.oneShotPrice"
                        :illustration="fundingDetails.cb4xPopin.imageZen"
                    />
                </template>
                <!-- Payez en 12x, 24x, 36x ou 48x  -->
                <template v-if="devicePrice.price.pxfAvailable" #pxf-content>
                    <pxf-modal-content
                        :header-block-dto="fundingDetails.pxfPopin.headerBlockDto"
                        :example-pxf-data="fundingDetails.pxfPopin.examplePxfData"
                        :example-pxf-tab-subtitle="fundingDetails.pxfPopin.examplePxfTabSubtitle"
                        :example-pxf-tab-title="fundingDetails.pxfPopin.examplePxfTabTitle"
                        :version-pxf-data="devicePrice.price.versionPxfData"
                        :version-pxf-tab-title="fundingDetails.pxfPopin.versionPxfTabTitle"
                        :pxf-legal-mentions-text="fundingDetails.pxfPopin.pxfLegalMentionsText"
                        :illustration="fundingDetails.pxfPopin.imageZen"
                        :financing-block="fundingDetails.pxfPopin.financingBlock"
                        :cgu="fundingDetails.pxfPopin.cguDto"
                        :how-to-benefit-dto="fundingDetails.pxfPopin.howToBenefitDto"
                    />
                </template>
            </pxf-cb4x-modal>
        </div>

        <!--/* Prix téléphone seul */-->
        <p v-if="complementaryPriceLabel" class="pb-0" v-html="complementaryPriceLabel" />

        <eco-part-private-copying
            id="popin-ecopart-modal"
            :eco-part-label="devicePrice.ecoParticipationDTO.ecoParticipationLabel"
            :eco-part-link-label="devicePrice.ecoParticipationDTO.ecoParticipationLinkLabel"
            :eco-part-modal="devicePrice.ecoParticipationDTO.ecoParticipationModal"
            :private-copying-label="devicePrice.ecoParticipationDTO.privateCopyingLabel"
            :private-copying-link="devicePrice.ecoParticipationDTO.privateCopyingLink"
            :private-copying-link-label="devicePrice.ecoParticipationDTO.privateCopyingLinkLabel"
            :target="devicePrice.ecoParticipationDTO.ecoParticipationModal.target"
        />

        <!--/* Les garanties légales */-->
        <p v-if="showGuaranteeLegalMentions" class="small" v-html="guaranteeLegalMentionsLabel" />

        <!--/* Engagement */-->
        <section
            v-if="commitment"
        >
            <p
                v-if="commitment.withCommitment"
                class="pb-0 fw-bold"
                v-html="commitment.text"
            />
            <ob1-message-alerte
                v-else
                :title="commitment.text"
                type="info"
            />
        </section>
    </div>
</template>

<script>
import Cb4xPxfMention from "../../../common/fragments/mobile/Cb4xPxfMention.vue";
import DevicePrice from "../../../common/components/ob1/DevicePrice.vue";
import PxfCb4xModal from "../../common/components/PxfCb4xModal.vue";
import Cb4xModalContent from "../../common/components/Cb4xModalContent.vue";
import PayingDetailCb4xModalContent from "../../common/components/PayingDetailCb4xModalContent.vue";
import PxfModalContent from "../../common/components/PxfModalContent.vue";
import PromoPrixTerminal from "../../common/PromoPrixTerminal.vue";
import EcoPartPrivateCopying from "../../common/fragments/EcoPartPrivateCopying.vue";

export default {
    name: "DeviceDetailPrice",
    components: {
        DevicePrice,
        EcoPartPrivateCopying,
        PromoPrixTerminal,
        Cb4xModalContent,
        PxfCb4xModal,
        Cb4xPxfMention,
        PayingDetailCb4xModalContent,
        PxfModalContent,
    },
    props: {
        devicePrice: {
            type: Object,
            required: true
        },
        isPriceInversionEnabled: {
            type: Boolean,
            required: true
        },
        loanRateZeroLabel: {
            type: String,
            required: true
        },
        loanRateZeroOfferLabel: {
            type: String,
            default: null
        },
        fundingDetails: {
            type: Object,
            required: true
        },
        showGuaranteeLegalMentions: {
            type: Boolean,
            required: false,
            default: false
        },
        guaranteeLegalMentionsLabel: {
            type: String,
            required: false,
            default: undefined
        },
        commitment:{
            type: Object,
            default: null
        },
        complementaryPriceLabel: {
            type: String,
            required: false,
            default: undefined
        },
    },
    methods: {
        getLoanRateZeroLabel: function (price) {
            if (price.monthlyPayment?.taegRate === 0) {
                return this.loanRateZeroLabel;
            } else if (price.monthlyPayment == null && price.hasZeroTaeg) {
                return this.loanRateZeroOfferLabel;
            } else {
                return null;
            }
        },
        isPriceInversionEnabledForDevice: function (price) {
            return this.isPriceInversionEnabled && !!price?.monthlyPayment?.monthlyAmountInCents;
        },
    }
}
</script>
